import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import LineChart from '../../charts/LineExample'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {

  name: 'confirm-line-haul-connection',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    LineChart
  },
  data: function() {
    return {
      hubName: "",
      isLoading: false,
      isDisplay: true,
      shippingid: "",
      bagno: "",
      binno: "",
      confirmclose: false,
      isDisabledOK: false,
      invalidTokenModal: false,
      invalidtokenmsg: '',
      date: '',
      loaded: false,
      disableDate:false,
      disableBin:false,
      chartdata: {
        labels: [],
        datasets: [{
          backgroundColor: '#85929E',
          pointBackgroundColor: '#85929E',
          pointHoverBackgroundColor: '#85929E',
          borderColor: '#85929E',
          pointBorderColor: '#85929E',
          pointHoverBorderColor: '#85929E',
          fill: false,
          label: 'Bag Count',
          data: []
        }]
      },
      options: {
        scales: {
          xAxes: [{
            gridLines: {
                    display: true,
                },
          }],
          yAxes: [{
            gridLines: {
                    display: true,
                },
            ticks: {
              stepSize: 10
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  created: function() {},
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail[0].email;
    this.hubId = userdetail[0].HubId[0];
    this.getHubName(userdetail[0].HubId);
  },
  methods: {
    getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
    onSubmit: function() {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            return false;
          } else {
            this.showHourlyHubBagCount();
          }
        }).catch(() => {
          console.log('errors exist', this.errors);
        });
    },
    showHourlyHubBagCount() {
      this.isLoading = true;
      let urlnew
      if (this.binno != '' || this.binno != null) {
        urlnew = apiUrl.api_url_hubops + "getHourlyHubBagCount?currentHubId=[" + this.hubId + ']&date=' + moment(this.date).format('YYYY-MM-DD') + '&binNumber=' + this.binno
      } else {
        urlnew = apiUrl.api_url_hubops + "getHourlyHubBagCount?currentHubId=[" + this.hubId + ']&date=' + moment(this.date).format('YYYY-MM-DD')
      }

      axios({
          method: 'GET',
          'url': urlnew,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.disableDate = true
            this.disableBin=true
            result.data.ResponseData.map(item => {
              this.chartdata.labels.push(item.bagtime)
              this.chartdata.datasets[0].data.push(item.bagcount)
            })
            this.loaded = true
            this.$alertify.success(result.data.ReturnMessage)
            this.invalidTokenModal = false
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    resetForm() {
      this.disableDate=false
      this.disableBin=false
      this.chartdata = {
        labels: [],
        datasets: [{
          backgroundColor: '#85929E',
          pointBackgroundColor: '#85929E',
          pointHoverBackgroundColor: '#85929E',
          borderColor: '#85929E',
          pointBorderColor: '#85929E',
          pointHoverBorderColor: '#85929E',
          fill: false,
          label: 'Bag Count',
          data: []
        }]
      }
      this.options= {
        scales: {
          xAxes: [{
            gridLines: {
                    display: true,
                },
          }],
          yAxes: [{
            gridLines: {
                    display: true,
                },
            ticks: {
              stepSize: 1
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false
      }
      this.date = ''
      this.loaded = false
      this.isDisabledOK = false
      this.binno = "";
      this.bagno = "";
      this.isLoading = false;
      this.showTable = false;
      this.$validator.reset();
      this.errors.clear();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanToBagReport/ScanToBagReport.js